import { render, staticRenderFns } from "./ListItemSkeleton.vue?vue&type=template&id=cf5ff6f2&"
import script from "./ListItemSkeleton.vue?vue&type=script&lang=js&"
export * from "./ListItemSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports